import {
  CButton,
  CCardHeader,
  CCol,
  CInput,
  CLabel,
  CRow,
  CInputGroup,
  CSpinner,
  CTextarea,
  CForm,
  CSelect,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Auth from "src/auth";
import { formatDate } from "src/shared/Format/dateFormat";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";
import { Paper } from "@mui/material";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/system";
import CommonList from "../crud/CommonList";

const TransferLotDetails = () => {
  let history = useHistory();

  let { lotId } = useParams();
  const Backdrop = styled("div")`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-tap-highlight-color: transparent;
  `;
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    borderRadius: "4px",
    fontSize: "1rem",
    padding: "2rem",
  };
  // var q = new Date();
  // var m = q.getMonth();
  // var d = q.getDay();
  // var y = q.getFullYear();
  // var date = new Date(y, m, d);
  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();

  const [viewListDetails, setviewListDetails] = useState();
  const [viewListDocument, setviewListDocument] = useState();
  const [viewTenderDetails, setviewTenderDetails] = useState();
  const [EmdPaid, setEmdPaid] = useState();
  const [viewTransferDetails, setviewTransferDetails] = useState([]);
  const [viewPaymentDetails, setviewPaymentDetails] = useState([]);
  const [viewPaymentSlotsData, setviewPaymentSlotsData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [payTransferFee, setpayTransferFee] = useState(true);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [agreementextendopen, setagreementextendopen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [agreementextendLotId, setagreementextendLotId] = useState("");
  const [agreementextendLastDate, setagreementextendLastDate] = useState("");
  const [agreementextendComments, setagreementextendComments] = useState();
  const [agreementextendLotNo, setagreementextendLotNo] = useState("");
  const [agreementextendamount, setagreementextendamount] = useState("");
  const [
    agreementextendamountdescription,
    setagreementextendamountdescription,
  ] = useState("");
  const [is7dayextention, setis7dayextention] = useState(false);

  const [openRevoke, setOpenRevoke] = useState(false);
  const [paymentSlotId, setpaymentSlotId] = useState("");
  const [isAnyPaidSlots, setisAnyPaidSlots] = useState(true);
  const [designation, setdesignation] = useState();

  const handleOpenagreementextend7day = (
    lotid,
    lotNo,
    latdate,
    amout,
    amountdescription
  ) => {
    setagreementextendopen(true);
    setis7dayextention(true);
    setagreementextendLotId(lotid);
    setagreementextendLotNo(lotNo);
    setagreementextendLastDate(latdate);
    setagreementextendamount(amout);
    setagreementextendamountdescription(amountdescription);
  };

  const handleOpenagreementextend15March = (
    lotid,
    lotNo,
    latdate,
    amout,
    amountdescription
  ) => {
    setis7dayextention(false);
    setagreementextendopen(true);
    setagreementextendLotId(lotid);
    setagreementextendLotNo(lotNo);
    setagreementextendLastDate(latdate);
    setagreementextendamount(amout);
    setagreementextendamountdescription(amountdescription);
  };

  const HandlerAgreementPay = async () => {
    if (agreementextendComments === null || agreementextendComments === "") {
      alert("Please enter the comment");
    } else {
      history.push(
        `/SubmitAgreementExtend/${lotId}/${window.btoa(
          agreementextendComments
        )}/${is7dayextention}/${agreementextendamount}`,
        {
          from: window.location.href,
        }
      );
    }
  };

  const deletedocument = async (id) => {
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `LotDetails/Deletedocument?id=${id}`,
      "PUT",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      window.location.reload();
    }
  };

  // function makeid(length) {
  //   var result = "";
  //   var characters =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   var charactersLength = characters.length;
  //   for (var i = 0; i < length; i++) {
  //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  //   }
  //   return result;
  // }

  // const HandlerAgreement7DayPay = async () => {
  //   const header = new Headers();
  //   header.append("Content-Type", "application/json");
  //   const response = await apiCall(
  //     "LotDetails/agreementExtend7Day",
  //     "POST",
  //     header,
  //     JSON.stringify({
  //       comment: agreementextend7dayComments,
  //       sessionId: makeid(35),
  //       lotid: decrypted,
  //       returnUrl: API_BASE_URL +'PaymentResponse',
  //       cancelUrl: PAYMNET_CANCEL_URL+'?value='+decrypted
  //     })
  //   );

  //   const jsonobj = await response.json();
  //
  //     if (response.status === 200) {
  //       history.push(`/SubmitAgreementExtend7Day/${window.btoa(jsonobj.message)}`, {
  //              from: window.location.href,
  //       });
  //     }
  // };

  const handleOpenRevoke = (id) => {
    setpaymentSlotId(id);
    setOpenRevoke(true);
  };
  const handleagreementextendclose = () => setagreementextendopen(false);
  const handleCloseRevoke = () => setOpenRevoke(false);
  const [showList, setshowList] = useState();
  const [terminationMsg, setterminationMsg] = useState();
  const [revokeDate, setrevokeDate] = useState();
  const [revokeMsg, setrevokeMsg] = useState();
  //const [terminationDate, setterminationDate] = useState("");

  // const [txtId, settxtId] = useState("");

  const { authenticated } = Auth();
  const decrypted = window.atob(lotId);
  const [selectedFile, setSelectedFile] = useState();
  const [fileEvent, setFileEvent] = useState(false);
  const [documentName, setdocumentName] = useState("");

  const BGPaymentHandler = async (lotid, type) => {
    history.push(`/OfflinePaymentWithType/${lotId}/${type}`, {
      from: window.location.href,
    });
  };

  const handleDownloadAgreementLetter = async (tenderid, lotid, userid) => {
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/DownloadAgreementLetter?tenderId=${Number(
        tenderid
      )}&lotid=${lotid}&userid=${Number(userid)}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = lotid + "_Bidder" + userid + "_Original.pdf";
        alink.click();
      });
    }
  };

  const DownloadTransferLetter = async (lotid) => {
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/DownloadTransferLetter?lotid=${Number(lotid)}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = lotid + ".pdf";
        alink.click();
      });
    }
  };

  const fieldsNodelete = [
    {
      key: "createdDate",
      label: <div>Created Date</div>,
    },
    {
      key: "fileName",
      label: <div>File Name</div>,
    },
    {
      key: "viewLotDocument",
      label: "View LotDocument",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  const fields = [
    {
      key: "createdDate",
      label: <div>Created Date</div>,
    },
    {
      key: "fileName",
      label: <div>File Name </div>,
    },
    {
      key: "viewLotDocument",
      label: "View LotDocument",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "deleteLotDocument",
      label: "Delete LotDocument",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  // function makeid(length) {
  //   var result = "";
  //   var characters =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   var charactersLength = characters.length;
  //   for (var i = 0; i < length; i++) {
  //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  //   }
  //   return result;
  // }
  const FullPaymentHanlder = async (amount) => {
    history.push(`/submitpayment/${decrypted}/${amount}`, {
      from: window.location.href,
    });
  };

  //const ViewBGHandler = () => {};

  const PaymentStatusViewHanlder = async (tranid) => {
    history.push(`/receipt/${tranid}`, {
      from: window.location.href,
    });
  };

  const CancelChallanHanlder = async (paymentId) => {
    if (authenticated) {
      const header = new Headers();
      const response = await apiCall(
        `LotDetails/cancelChallan?paymentId=${paymentId}`,
        "GET",
        header,
        null
      );
      const jsonobj = await response.json();
      if (response.status === 200 && jsonobj === true) {
        window.location.reload();
        setshowList(false);
        getLotDetails(true);
      }
    }
  };

  const PaymentHanlder = async (amount) => {
    history.push(`/submitpayment/${decrypted}/${amount}`, {
      from: window.location.href,
    });
  };

  const TransferLotEMDPayment = async (paymenttype) => {
    if (paymenttype === 15) {
      console.log("LOTID:" + window.atob(lotId));
      history.push(`/SelectyourpaymentForTransferlotEMD/${lotId}`, {
        from: window.location.href,
      });
    } else {
      history.push(
        `/submitlottransferemdpayment/${lotId}/${window.btoa(paymenttype)}`,
        {
          from: window.location.href,
        }
      );
    }
  };

  const updateAgreement = async (isAgreementAccepted) => {
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `LotDetails/updateIsAgreementAccepted?lotId=${decrypted}&isAgreementAccepted=${isAgreementAccepted}`,
      "PUT",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
      window.location.reload();
      setshowList(false);
      getLotDetails(true);
    }
  };

  const generateAadeshLetter = async () => {
    let letterurl = `${downloadUrl}/ParidhanAadeshLetters/15078_paridhanaadesh.pdf`;
    window.open(letterurl, "_blank");

    // const header = new Headers();
    // const response = await apiCall(
    //   `LotDetails/GenerateParidhanAadeshLetter?lotId=${decrypted}`,
    //   "GET",
    //   header,
    //   null
    // );
    // const jsonobj = await response.json();
    // if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
    //   let letterurl = `${downloadUrl}/ParidhanAadeshLetters/${decrypted}/${decrypted}.pdf`;
    //   window.open(letterurl, "_blank");
    // }
  };

  const updateSanction = async (isSanctionAccepted) => {
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `LotDetails/updateIsSanctionAccepted?lotId=${decrypted}&isSanctionAccepted=${isSanctionAccepted}`,
      "PUT",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
      window.location.reload();
      setshowList(false);
      getLotDetails(true);
    }
  };

  const terminateLot = async (e) => {
    e.preventDefault();
    handleClose();
    setshowList(false);
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `LotDetails/TerminateLot?lotId=${decrypted}&msg=${terminationMsg}`,
      "PUT",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      window.location.reload();
      setshowList(false);
      setOpen(false);
      getLotDetails(true);
    }
  };

  const revokeLot = async (e) => {
    e.preventDefault();
    handleCloseRevoke();
    setshowList(false);
    const header = new Headers();
    //  header.append("", "");

    const response = await apiCall(
      `LotDetails/RevokeLot?lotId=${decrypted}&msg=${revokeMsg}&paymentSlotId=${paymentSlotId}&newTeminationDate=${revokeDate}`,
      "PUT",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      window.location.reload();
      setshowList(false);
      getLotDetails(true);
    }
  };

  const submitAgreementExtend7Day = async (e) => {
    e.preventDefault();
    handleCloseRevoke();
    setshowList(false);
    const header = new Headers();
    //  header.append("", "");

    const response = await apiCall(
      `LotDetails/RevokeLot?lotId=${decrypted}&msg=${revokeMsg}&paymentSlotId=${paymentSlotId}&newTeminationDate=${revokeDate}`,
      "PUT",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      window.location.reload();
      setshowList(false);
      getLotDetails(true);
    }
  };

  const getLotDocument = async (e) => {
    if (authenticated) {
      const header = new Headers();
      const response = await apiCall(
        `LotDetails/GetAllDocumentByLotId?lotId=${e}`,
        "GET",
        header,
        null
      );
      const jsonobj = await response.json();
      if (response.status === 200) {
        setviewListDocument(jsonobj);
      }
    }
  };

  const AgreementUpload = async (id) => {
    let e = fileEvent;
    if (e !== false) {
      if (authenticated) {
        let isValidfile = false;
        viewListDocument.forEach((data) => {
          if (data.type === "agreementletters") {
            if (
              e.target.files[0] !== undefined &&
              e.target.files[0].name.toLowerCase() ===
                "signed_" + data.fileName.toLowerCase()
            ) {
              isValidfile = true;
            }
          }
        });
        if (!isValidfile) {
          alert("Invalid File.");
        } else if (designation === undefined || designation === "0") {
          alert("Please select designation.");
        } else if (e.target.files[0].type === "application/pdf") {
          e.preventDefault();
          // setSelectedFile(e.target.files[0]);
          const files = e.target.files;
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");
          formData.append("file", files[0]);
          const response = await apiCall(
            `LotDetails/UploadAgreementByBidder/${id}/${e.target.files[0].name}/${designation}`,
            "POST",
            header,
            formData
          );
          await response.text();
          if (response.status === 200) {
            viewListDetails.agreementStatus = 1;
            alert("Uploaded Successfully!");
            setSelectedFile();
            setFileEvent(false);
            getLotDetails(true);
          } else {
            alert("Error to upload file!");
          }
        } else {
          alert("Please Upload Only pdf file!");
        }
      }
    } else {
      alert("Please Choose A File!");
    }
  };
  const CFOAgreementUpload = async (id, cfoid) => {
    let e = fileEvent;
    if (e !== false) {
      if (authenticated) {
        let isValidfile = false;
        viewListDocument.forEach((data) => {
          if (data.type === "agreementletters") {
            if (
              e.target.files[0].name.toLowerCase() ===
              "signed_signed_" + data.fileName.toLowerCase()
            ) {
              isValidfile = true;
            }
          }
        });
        if (!isValidfile) {
          alert("Invalid File.");
        } else if (e.target.files[0].type === "application/pdf") {
          e.preventDefault();
          setSelectedFile(e.target.files[0]);
          const files = e.target.files;
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");
          formData.append("file", files[0]);
          const response = await apiCall(
            `LotDetails/UploadAgreementByCFO/${id}/${cfoid}`,
            "POST",
            header,
            formData
          );
          await response.text();
          if (response.status === 200) {
            viewListDetails.agreementStatus = 2;
            alert("Uploaded Successfully!");
            setSelectedFile();
            setFileEvent(false);
            getLotDetails(true);
          } else {
            alert("Error to upload file!");
          }
        } else {
          alert("Please Upload Only pdf file!");
        }
      }
    } else {
      alert("Please Choose A File!");
    }
  };
  const getLotDetails = async (firstRequest) => {
    if (authenticated) {
      const header = new Headers();
      // header.append("", "");

      const response = await apiCall(
        //`LotDetails/GetLotDetailsById?$filter=lotId eq ${decrypted}`,
        `LotDetails/GetLotDetailsById?lotid=${decrypted}`,
        "GET",
        header,
        null
      );
      const jsonobj = await response.json();
      if (response.status === 200) {
        setviewListDetails(jsonobj[0]);
        getLotDocument(jsonobj[0].lotId);
        const responseData = await apiCall(
          `Tender/GetLotDetails?$filter=tenderId eq ${jsonobj[0].tenderId}`,
          "GET",
          header,
          null
        );
        const jsonobjData = await responseData.json();
        if (responseData.status === 200) {
          setviewTenderDetails(jsonobjData[0]);
          const responseCheckEMDPaid = await apiCall(
            `LotDetails/CheckEMDPaid?LotId=${decrypted}`,
            "GET",
            header,
            null
          );

          const jsonobjCheckEMDPaid = await responseCheckEMDPaid.json();
          setEmdPaid(jsonobjCheckEMDPaid);

          const responseSlotsData = await apiCall(
            `LotDetails/getlotpaymentslots?LotId=${decrypted}`,
            "GET",
            header,
            null
          );
          const jsonobjSlotsData = await responseSlotsData.json();
          if (responseSlotsData.status === 200 && jsonobjSlotsData.length > 0) {
            setviewPaymentSlotsData(jsonobjSlotsData);
            var paidRecords = jsonobjSlotsData.filter(
              (l) => l.paymentId != null && l.paymentId > 0
            ).length;
            setisAnyPaidSlots(paidRecords);
          }

          const responseTransferData = await apiCall(
            `LotTransfer?$filter=lotId eq ${decrypted}`,
            "GET",
            header,
            null
          );
          const jsonobjTransferData = await responseTransferData.json();
          if (
            responseTransferData.status === 200 &&
            jsonobjTransferData.length > 0
          ) {
            setviewTransferDetails(jsonobjTransferData);

            jsonobjTransferData.map(async (data) => {
              const responsePaymentData = await apiCall(
                `OfflinePayment/Get?$filter=objectId eq ${data.lotTransferId}`,
                "GET",
                header,
                null
              );
              const jsonobjPaymentData = await responsePaymentData.json();

              if (
                responsePaymentData.status === 200 &&
                jsonobjPaymentData.length > 0
              ) {
                jsonobjPaymentData.map((paymentData) => {
                  let arr = viewPaymentDetails;
                  let condition = arr.find(
                    (data) => data.id === paymentData.id
                  );

                  if (
                    condition === undefined &&
                    jsonobjPaymentData.length > 0
                  ) {
                    arr.push(paymentData);
                    setviewPaymentDetails(arr);

                    // if (paymentData.status === 2) {
                    //   setpayTransferFee(true);
                    // } else if (
                    //   paymentData.status === 0 ||
                    //   paymentData.status === 1
                    // ) {
                    //   setpayTransferFee(false);
                    // } else {
                    //   setpayTransferFee(true);
                    // }
                  }
                });
              }
            });
          }
          setshowList(true);
        }
      }
    } else {
      setshowList(false);
    }
  };

  useEffect(() => {
    getLotDetails(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotId, authenticated, payTransferFee, showList]);

  return (
    <>
      {!showList ? (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      ) : (
        authenticated &&
        viewTenderDetails && (
          <CCardHeader>
            <CRow className="pt-3" xl={12}>
              <CCol className="mb-2" xl={10}>
                <h3>Lot Details</h3>
              </CCol>
            </CRow>
            <div className="pl-5 pr-5">
              <hr />

              <CRow className="mt-3">
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Lot number :
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.lotNo === null
                        ? " "
                        : viewListDetails.lotNo
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Quantity :</CLabel>
                  <CInput
                    value={
                      viewListDetails.quantity === null
                        ? " "
                        : viewListDetails.quantity
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Purchase Rate :
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.purchaseRate === null
                        ? " "
                        : viewListDetails.purchaseRate
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Purchase Price :
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.purchasePrice === null
                        ? " "
                        : viewListDetails.purchasePrice
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Status :</CLabel>
                  <CInput
                    value={
                      viewListDetails.status === null
                        ? " "
                        : viewListDetails.status
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Emd Amount :{" "}
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.emdAmount === null
                        ? " "
                        : viewListDetails.emdAmount
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Society : </CLabel>
                  <CInput
                    value={
                      viewListDetails.socity === null
                        ? " "
                        : viewListDetails.socity
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    District Union :{" "}
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.districtName === null
                        ? " "
                        : viewListDetails.districtName
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Circle Name :{" "}
                  </CLabel>
                  <CInput
                    value={
                      viewListDetails.circleName === null
                        ? " "
                        : viewListDetails.circleName
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <hr />
            </div>
            {/* <CRow className="pt-3" xl={12}>
                <CCol className="mb-2" xl={10}>
                  <h3>LotDocument</h3>
                </CCol>
              </CRow> */}
            <br />
            {authenticated.role === "Bidder" &&
              viewListDetails.isSanctionAccepted === 1 &&
              ((viewListDetails.isAgreementAccepted === 1 &&
                viewListDetails.agreementStatus === 0) ||
                EmdPaid.isEMDPaid === true) && (
                <>
                  <CCardHeader className="mb-3">
                    <CRow className="pt-3" xl={6}>
                      <CCol xl={6}>
                        <h3>Upload Document</h3>
                      </CCol>
                    </CRow>
                    <hr />
                    <CRow className="mb-3">
                      <CCol xl={2}>
                        <CLabel
                          htmlFor="formFile"
                          className="col-sm-12 col-form-label"
                        >
                          Upload Document
                        </CLabel>
                      </CCol>
                      <CCol xl={3}>
                        <CInputGroup className="mb-3">
                          <div className="custom-file">
                            <input
                              disabled={
                                viewListDetails.isDisableUploadDocumentForBidder
                              }
                              name="file"
                              id="inputGroupFile01"
                              type="file"
                              accept=".pdf"
                              className="custom-file-input"
                              onChange={(e) => {
                                setFileEvent(e);
                                setSelectedFile(e.target.files[0]);
                              }}
                            />
                            <label
                              className="custom-file-label "
                              htmlFor="inputGroupFile01"
                            >
                              {selectedFile ? (
                                selectedFile.name
                              ) : (
                                <>Choose file</>
                              )}
                            </label>
                          </div>
                        </CInputGroup>
                      </CCol>
                      <CLabel className="col-form-label">Designation</CLabel>
                      <CCol xl={2}>
                        <CSelect
                          disabled={
                            viewListDetails.isDisableUploadDocumentForBidder
                          }
                          aria-label="Default select example"
                          onChange={(e) => {
                            setdesignation(e.target.value);
                          }}
                        >
                          <option value="0">Select Designation</option>
                          <option value="1">Individual</option>
                          <option value="2">Proprietor</option>
                          <option value="3">Partner</option>
                          <option value="4">Director</option>
                          <option value="5">HUF Karta/Member</option>
                          <option value="6">Trustee</option>
                          <option value="7">Other Authorized Signatory</option>
                        </CSelect>
                      </CCol>
                      <CLabel className="col-form-label">Document Name</CLabel>
                      <CCol xl={3}>
                        <CInputGroup className="mb-3">
                          <CInput
                            disabled={
                              viewListDetails.isDisableUploadDocumentForBidder
                            }
                            type="text"
                            value={documentName}
                            name="documentName"
                            onChange={(e) => setdocumentName(e.target.value)}
                          />

                          <CButton
                            className="ml-3"
                            color="success"
                            hidden="true"
                            disabled={
                              viewListDetails.isDisableUploadDocumentForBidder
                            }
                            onClick={() =>
                              AgreementUpload(viewListDetails.lotId)
                            }
                          >
                            Upload Document
                          </CButton>
                        </CInputGroup>
                      </CCol>
                    </CRow>
                  </CCardHeader>
                </>
              )}

            {(authenticated.role === "CFO" || authenticated.role === "DFO") &&
              ((viewListDetails.agreementStatus === 1 &&
                viewListDetails.isAgreementAccepted === 1) ||
                EmdPaid.isEMDPaid === true) && (
                <>
                  <CCardHeader className="mb-3">
                    <CRow className="pt-3" xl={6}>
                      <CCol xl={6}>
                        <h3>Upload Document</h3>
                      </CCol>
                    </CRow>
                    <hr />
                    <CRow className="mb-3">
                      <CCol xl={2}>
                        <CLabel
                          htmlFor="formFile"
                          className="col-sm-12 col-form-label"
                        >
                          Upload Document
                        </CLabel>
                      </CCol>
                      <CCol xl={4}>
                        <CInputGroup className="mb-3">
                          <div className="custom-file">
                            <input
                              disabled={
                                viewTenderDetails.isDisableUploadDocumentForCFO
                              }
                              name="file"
                              id="inputGroupFile01"
                              type="file"
                              accept=".pdf"
                              className="custom-file-input"
                              onChange={(e) => {
                                setFileEvent(e);
                                setSelectedFile(e.target.files[0]);
                              }}
                            />
                            <label
                              className="custom-file-label"
                              htmlFor="inputGroupFile01"
                            >
                              {selectedFile ? (
                                selectedFile.name
                              ) : (
                                <>Choose file</>
                              )}
                            </label>
                          </div>
                          <div>
                            <CButton
                              className="ml-3"
                              hidden="true"
                              disabled={
                                viewTenderDetails.isDisableUploadDocumentForCFO
                              }
                              color="success"
                              onClick={() =>
                                CFOAgreementUpload(
                                  viewListDetails.lotId,
                                  authenticated.userId
                                )
                              }
                              // enabled={uploadBtn === false ? true : false}
                            >
                              Upload Document
                            </CButton>
                          </div>
                        </CInputGroup>
                      </CCol>
                    </CRow>
                  </CCardHeader>
                </>
              )}
            <br />
            <CRow>
              <CCol xl={12}>
                <CommonList
                  items={viewListDocument}
                  fields={
                    viewListDetails?.isAllowToCCFDeleteTheBidderAgreement ===
                    true
                      ? fields
                      : fieldsNodelete
                  }
                  listName="Lot Documents"
                  loading={false}
                  path="/lotlistview/"
                  tabBtn="View"
                  id="lotId"
                  disabledprev={true}
                  disablednext={true}
                  isAllowToCCFDeleteTheBidderAgreement={
                    viewListDetails?.isAllowToCCFDeleteTheBidderAgreement
                  }
                  deletedocument={deletedocument}
                  tenderId={viewTenderDetails.tenderId}
                />
              </CCol>
            </CRow>
            <CRow className="pt-3" xl={12}>
              <CCol className="mb-2" xl={10}>
                <h3>Tender Details</h3>
              </CCol>
            </CRow>
            <div className="pl-5 pr-5">
              <hr />
              <CRow className="mt-3">
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Tender number :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.tenderNo === null
                        ? " "
                        : viewTenderDetails.tenderNo
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">Details :</CLabel>
                  <CInput
                    value={
                      viewTenderDetails.details === null
                        ? " "
                        : viewTenderDetails.details
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Publish Date :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.purchaseDate === null
                        ? " "
                        : formatDate(viewTenderDetails.purchaseDate)
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Rebate(%) :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.rebate === null
                        ? " "
                        : viewTenderDetails.rebate
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Late Fee Per Day(%) :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.lateFeePerDay === null
                        ? " "
                        : viewTenderDetails.lateFeePerDay
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Security Deposit Amount :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.securityDepositAmount === null
                        ? " "
                        : viewTenderDetails.securityDepositAmount
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Security Deposit Day :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.securityDepositDay === null
                        ? " "
                        : viewTenderDetails.securityDepositDay
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Total Lots :
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.totalLots === null
                        ? " "
                        : viewTenderDetails.totalLots
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
                <CCol className="mb-2" xl={4}>
                  <CLabel htmlFor="exampleFormControlInput1">
                    Collection Season :{" "}
                  </CLabel>
                  <CInput
                    value={
                      viewTenderDetails.collectionSeason === null
                        ? " "
                        : viewTenderDetails.collectionSeason
                    }
                    disabled
                    id="exampleFormControlInput1"
                  />
                </CCol>
              </CRow>
              {viewPaymentSlotsData !== undefined &&
                viewPaymentSlotsData.length > 0 &&
                viewTenderDetails && (
                  <CRow>
                    {[...Array(viewTenderDetails.paymentSlots)].map((e, i) => (
                      <>
                        {viewPaymentSlotsData[i]?.type === 0 &&
                          (viewPaymentSlotsData[i]?.paidBy === null ||
                            viewPaymentSlotsData[i]?.paidBy ===
                              authenticated.userId) && (
                            <>
                              <CCol className="mb-2" xl={4}>
                                <CLabel
                                  key={`Payment Due Date label ${i + 1}`}
                                  htmlFor="exampleFormControlInput1"
                                >
                                  {`Payment Due Date ${i + 1}`} :
                                </CLabel>
                                <CInput
                                  key={`Payment Due Date input ${i + 1}`}
                                  value={
                                    viewPaymentSlotsData[i].dueDate === null
                                      ? " "
                                      : formatDate(
                                          viewPaymentSlotsData[i].dueDate
                                        )
                                  }
                                  disabled
                                  id="exampleFormControlInput1"
                                />
                              </CCol>
                              <CCol className="mb-2" xl={2}>
                                <CLabel
                                  key={`Payment Complete label ${i + 1}`}
                                  htmlFor="exampleFormControlInput1"
                                >
                                  {`Payment ${i + 1} Complete`} :
                                </CLabel>
                                <CInput
                                  key={`Payment Complete input ${i + 1}`}
                                  value={
                                    viewTenderDetails.paymentDueDates[i]
                                      .paymentComplete === null
                                      ? " "
                                      : viewTenderDetails.paymentDueDates[i]
                                          .paymentComplete
                                  }
                                  disabled
                                  id="exampleFormControlInput1"
                                />
                              </CCol>
                              <CCol className="mb-2 mt-1" xl={2}>
                                <CInput
                                  key={`Payment percentage input ${i + 1}`}
                                  className="mt-4"
                                  value={
                                    viewTenderDetails.paymentDueDates[i]
                                      .paymentComplete === null
                                      ? " "
                                      : viewPaymentSlotsData[i].paymentAmount
                                    // (
                                    //     (viewTenderDetails.paymentDueDates[i]
                                    //       .paymentComplete /
                                    //       100) *
                                    //     viewListDetails.purchasePrice
                                    //   ).toFixed(2)
                                  }
                                  disabled
                                  id="exampleFormControlInput1"
                                />
                              </CCol>
                              {authenticated.role === "CGMF" && (
                                <>
                                  <CCol className="mb-2 mt-1" xl={2}>
                                    <CInput
                                      key={`Payment percentage input ${i + 1}`}
                                      className="mt-4"
                                      value={
                                        viewPaymentSlotsData[i]
                                          .terminationDate === null
                                          ? " "
                                          : formatDate(
                                              viewPaymentSlotsData[i]
                                                .terminationDate
                                            )
                                      }
                                      disabled
                                      id="exampleFormControlInput1"
                                    />
                                  </CCol>
                                  {new Date(date) >
                                    new Date(
                                      viewPaymentSlotsData[i].terminationDate
                                    ) &&
                                    viewPaymentSlotsData[i].paymentId ===
                                      null &&
                                    viewListDetails.status !== "Terminated" && (
                                      <CCol xl={1} className="mt-4">
                                        <CButton
                                          key={`Terminate ${i + 1}`}
                                          className={"mt-1"}
                                          color="info"
                                          onClick={handleOpen}
                                          hidden="true"
                                        >
                                          Terminate
                                        </CButton>
                                      </CCol>
                                    )}

                                  {viewListDetails.status === "Terminated" &&
                                    new Date(date) >
                                      new Date(
                                        viewPaymentSlotsData[i].terminationDate
                                      ) &&
                                    viewPaymentSlotsData[i].paymentId ===
                                      null && (
                                      <CCol xl={1} className="mt-4">
                                        <CButton
                                          hidden="true"
                                          key={`Revoke ${i + 1}`}
                                          color="info"
                                          className={"mt-1"}
                                          onClick={() =>
                                            handleOpenRevoke(
                                              viewPaymentSlotsData[i].id
                                            )
                                          }
                                        >
                                          Revoke
                                        </CButton>
                                      </CCol>
                                    )}
                                </>
                              )}
                              {authenticated.role === "Bidder" &&
                              viewListDetails.status !== "Terminated" &&
                              viewPaymentSlotsData[i]?.isPayNowAllow &&
                              viewTenderDetails.isAgreementLetterGenerated &&
                              EmdPaid.isSignedByCFO === true &&
                              viewListDetails.isAgreementAccepted === 1 ? (
                                <CCol xl={2} className="mt-4 mb-2">
                                  <CButton
                                    key={`Payment now ${i + 1}`}
                                    color="info"
                                    hidden="true"
                                    className={"mt-1"}
                                    onClick={() =>
                                      PaymentHanlder(
                                        viewPaymentSlotsData[i].paymentAmount
                                      )
                                    }
                                  >
                                    Pay Now
                                  </CButton>
                                </CCol>
                              ) : viewPaymentSlotsData[i]?.paymentNotes !==
                                  "" &&
                                !viewPaymentSlotsData[
                                  i
                                ]?.paymentNotes?.includes("Challan") &&
                                viewPaymentSlotsData[i]?.tranId !== null ? (
                                <CCol xl={4} className="mt-4">
                                  {viewPaymentSlotsData[i]?.paymentNotes}
                                  <br />
                                  <CButton
                                    color="info"
                                    onClick={() =>
                                      PaymentStatusViewHanlder(
                                        viewPaymentSlotsData[i]?.tranId
                                      )
                                    }
                                    className="mr-5 mt-1 float-right"
                                  >
                                    View Receipt
                                  </CButton>
                                </CCol>
                              ) : authenticated.role === "Bidder" &&
                                viewPaymentSlotsData[i]?.paymentNotes !== "" &&
                                viewPaymentSlotsData[i]?.paymentNotes?.includes(
                                  "Challan"
                                ) &&
                                viewPaymentSlotsData[i]?.paymentNotes?.includes(
                                  "Awai ting"
                                ) ? (
                                <CCol xl={4} className="mt-4">
                                  {viewPaymentSlotsData[i]?.paymentNotes}
                                  <br />
                                  <CButton
                                    color="info"
                                    onClick={() =>
                                      PaymentStatusViewHanlder(
                                        viewPaymentSlotsData[i]?.tranId
                                      )
                                    }
                                    className="mr-5 mt-1 float-right"
                                  >
                                    View Receipt
                                  </CButton>
                                  <CButton
                                    color="info"
                                    hidden="true"
                                    onClick={() =>
                                      CancelChallanHanlder(
                                        viewPaymentSlotsData[i]?.paymentId
                                      )
                                    }
                                    className="mr-5 mt-1 float-right"
                                  >
                                    Cancel Challan
                                  </CButton>
                                </CCol>
                              ) : viewPaymentSlotsData[i]?.paymentNotes !==
                                  "" &&
                                viewPaymentSlotsData[i]?.paymentNotes?.includes(
                                  "Challan"
                                ) &&
                                !viewPaymentSlotsData[
                                  i
                                ]?.paymentNotes?.includes("Awaiting") ? (
                                <CCol xl={4} className="mt-4">
                                  {viewPaymentSlotsData[i]?.paymentNotes}
                                  <br />
                                  <CButton
                                    color="info"
                                    onClick={() =>
                                      PaymentStatusViewHanlder(
                                        viewPaymentSlotsData[i]?.tranId
                                      )
                                    }
                                    className="mr-5 mt-1 float-right"
                                  >
                                    View Receipt
                                  </CButton>
                                </CCol>
                              ) : (
                                authenticated.role !== "CGMF" && (
                                  <CCol xl={2} className="mt-4">
                                    {viewPaymentSlotsData[i]?.paymentNotes}
                                    {viewPaymentSlotsData[i]?.paymentNotes !==
                                      "" &&
                                    viewPaymentSlotsData[i]?.tranId !== null ? (
                                      <CButton
                                        color="info"
                                        onClick={() =>
                                          PaymentStatusViewHanlder(
                                            viewPaymentSlotsData[i]?.tranId
                                          )
                                        }
                                        className="mr-5 mt-1 float-right"
                                      >
                                        View Receipt
                                      </CButton>
                                    ) : (
                                      ""
                                    )}
                                  </CCol>
                                )
                              )}
                            </>
                          )}{" "}
                      </>
                    ))}
                  </CRow>
                )}
              {authenticated.role === "Bidder" &&
              viewListDetails.status !== "Terminated" &&
              viewTenderDetails?.isAgreementLetterGenerated &&
              EmdPaid.isSignedByCFO === true &&
              viewPaymentSlotsData.length > 0 &&
              viewPaymentSlotsData[0].isFullPayAllow &&
              viewListDetails.isAgreementAccepted === 1 ? (
                <CRow className="mt-3">
                  {" "}
                  <CCol style={{ marginRight: "41px", textAlign: "right" }}>
                    Full payment with 2% discount will be :{" "}
                    <strong>
                      {" "}
                      {parseFloat(
                        (98 / 100) * viewListDetails.purchasePrice
                      ).toFixed(2)}
                    </strong>
                    <br></br>
                    <CButton
                      color="info"
                      hidden="true"
                      onClick={() =>
                        FullPaymentHanlder(
                          (98 / 100) * viewListDetails.purchasePrice
                        )
                      }
                      className="mr-5 mt-1 float-right"
                    >
                      Pay full payment
                    </CButton>
                  </CCol>
                </CRow>
              ) : (
                ""
              )}
              {viewTransferDetails.length > 0 && <hr />}
            </div>
            {viewTransferDetails.length > 0 && (
              <>
                <CRow className="pt-3" xl={12}>
                  <CCol className="mb-2" xl={10}>
                    <h3>Transfer Details</h3>
                  </CCol>
                </CRow>
                {viewTransferDetails.map((data, key) => (
                  <div className="pl-5 pr-5">
                    <hr />
                    <CRow className="mt-3">
                      {authenticated.userId !== data.transferFromUserId && (
                        <CCol className="mb-2" xl={3}>
                          <CLabel
                            htmlFor="exampleFormControlInput1"
                            key={`label${key}`}
                          >
                            Transferor :
                          </CLabel>
                          <CInput
                            key={`Transfer from user${key}`}
                            value={
                              data.transferFromUser === null
                                ? " "
                                : data.transferFromUser
                            }
                            disabled
                            id="exampleFormControlInput1"
                          />
                        </CCol>
                      )}
                      <CCol className="mb-2" xl={3}>
                        <CLabel
                          key={`label Transfer to user${key}`}
                          htmlFor="exampleFormControlInput1"
                        >
                          Transferee :
                        </CLabel>
                        <CInput
                          key={`Transfer to user${key}`}
                          value={
                            data.transferToUser === null
                              ? " "
                              : data.transferToUser
                          }
                          disabled
                          id="exampleFormControlInput1"
                        />
                      </CCol>
                      <CCol className="mb-2" xl={1}>
                        <CLabel
                          key={`label Request Date${key}`}
                          htmlFor="exampleFormControlInput1"
                        >
                          Request Date :
                        </CLabel>
                        <CInput
                          key={`Request Date${key}`}
                          value={
                            data.requestDateTime === null
                              ? " "
                              : formatDate(data.requestDateTime)
                          }
                          disabled
                          id="exampleFormControlInput1"
                        />
                      </CCol>
                      <CCol className="mb-2" xl={1}>
                        <CLabel
                          key={`label Request Update Date${key}`}
                          htmlFor="exampleFormControlInput1"
                        >
                          Update Date :
                        </CLabel>
                        <CInput
                          key={`Request Update Date${key}`}
                          value={
                            data.requestUpdateDateTime === null
                              ? " "
                              : formatDate(data.requestUpdateDateTime)
                          }
                          disabled
                          id="exampleFormControlInput1"
                        />
                      </CCol>
                      <CCol className="mb-2" xl={2}>
                        <CLabel
                          key={`label comment${key}`}
                          htmlFor="exampleFormControlInput1"
                        >
                          Comment :
                        </CLabel>
                        <br></br>
                        {data.comments}
                      </CCol>
                      <CCol className="mb-2" xl={1}>
                        <CLabel
                          key={`label span${key}`}
                          htmlFor="exampleFormControlInput1"
                        >
                          Status :
                        </CLabel>
                        <h5>
                          {data.status === null ? (
                            " "
                          ) : data.status === 0 ? (
                            <span
                              key={`pending-span${key}`}
                              className="badge bg-warning text-dark"
                            >
                              Pending
                            </span>
                          ) : data.status === 1 ? (
                            <span
                              key={`Accepted-span${key}`}
                              className="badge bg-success text-light"
                            >
                              Accepted
                            </span>
                          ) : (
                            <span
                              key={`Rejected-span${key}`}
                              className="badge bg-danger text-light"
                            >
                              Rejected
                            </span>
                          )}
                        </h5>
                      </CCol>
                      <CCol className="mb-2" xl={1}>
                        <CLabel
                          key={`label approveduser span${key}`}
                          htmlFor="exampleFormControlInput1"
                        >
                          User Approved:
                        </CLabel>
                        <h5>
                          {data.isUserApproved === null ? (
                            <span
                              key={`pending-span${key}`}
                              className="badge bg-warning text-dark"
                            >
                              Pending
                            </span>
                          ) : data.isUserApproved === true ? (
                            <span
                              key={`Accepted-span${key}`}
                              className="badge bg-success text-light"
                            >
                              Accepted
                            </span>
                          ) : (
                            <span
                              key={`Rejected-span${key}`}
                              className="badge bg-danger text-light"
                            >
                              Rejected
                            </span>
                          )}
                        </h5>
                        {/* {viewPaymentDetails &&
                            viewPaymentDetails[key] &&
                            viewPaymentDetails[key].status} */}
                      </CCol>
                      {/* {viewPaymentDetails.map((detials, i) => {
                          if (
                            data.isUserApproved === true &&
                            authenticated.role === "Bidder" &&
                            data.status == 0 &&
                            viewPaymentDetails.length === 0
                          ) {
                            //for NO existing payment details
                            return (
                              <CCol className="mb-2" xl={2}>
                                <CButton
                                  className="mt-4"
                                  to={`/selectpaymentmethod/${data.lotTransferId}`}
                                  color="info"
                                >
                                  Pay Transfer Fee
                                </CButton>
                              </CCol>
                            );
                          } else if (
                            data.isUserApproved === true &&
                            authenticated.role === "Bidder" &&
                            // data.status === 0 &&
                            // detials &&
                            // detials.status === 2 &&
                            detials.objectId === data.lotTransferId
                          ) {
                            //for existing payment details
                            return (
                              <CCol className="mb-2" xl={2}>
                                <CButton
                                  className="mt-4"
                                  to={`/selectpaymentmethod/${data.lotTransferId}`}
                                  color="info"
                                >
                                  Pay Transfer Fee
                                </CButton>
                              </CCol>
                            );
                          } else if (
                            data.isUserApproved === true &&
                            authenticated.role === "Bidder"
                            // data.status === 0 &&
                            // detials &&
                            // detials.objectId === data.lotTransferId
                          ) {
                            return (
                              <CCol className="mb-2" xl={2}>
                                <CButton
                                  className="mt-4"
                                  to={`/selectpaymentmethod/${data.lotTransferId}`}
                                  color="info"
                                >
                                  Pay Transfer Fee
                                </CButton>
                              </CCol>
                            );
                          } else {
                            return <></>;
                          }
                        })} */}
                      {data.isUserApproved === true &&
                      authenticated.role === "Bidder" ? (
                        <CCol className="mb-2" xl={12}>
                          {data?.status === 1 &&
                          data.transferToUserId === authenticated.userId &&
                          data?.approvedByUserId !== null &&
                          (viewPaymentDetails.length === 0 ||
                            (viewPaymentDetails.length > 0 &&
                              viewPaymentDetails[viewPaymentDetails.length - 1]
                                .status === 2)) ? (
                            viewListDetails.lottransferpaymentdecription ===
                              null ||
                            viewListDetails.lottransferpaymentdecription ===
                              "" ? (
                              <>
                                <CRow>
                                  <CCol xl={4}>
                                    <strong className="ml-2">
                                      Amount : {viewListDetails.lotTransferFee}
                                    </strong>
                                  </CCol>
                                  <CCol xl={2}>
                                    <CButton
                                      hidden="true"
                                      onClick={() => {
                                        const location = {
                                          pathname: `/selectpaymentmethod/${data.lotTransferId}`,
                                          state: {
                                            lotId: decrypted,
                                          },
                                        };

                                        history.push(location);
                                      }}
                                      color="info"
                                    >
                                      Pay Transfer Fee
                                    </CButton>
                                  </CCol>
                                </CRow>
                              </>
                            ) : (
                              <>
                                <strong>Lot Transfer Fee Receipt</strong>
                                <hr></hr>
                                <CRow>
                                  <CCol xl={6}>
                                    {
                                      viewListDetails?.lottransferpaymentdecription
                                    }
                                  </CCol>
                                  <CCol xl={2}>
                                    {viewListDetails.islottransferpaymentBG ===
                                    true ? (
                                      <a
                                        target="_blank"
                                        href={`${downloadUrl}/${viewListDetails.lottransferpaymentidBGpath}`}
                                        rel="noreferrer"
                                      >
                                        <CButton
                                          color="info"
                                          className="mr-5 mt-1 float-right"
                                        >
                                          View BG
                                        </CButton>
                                      </a>
                                    ) : (
                                      <CButton
                                        color="info"
                                        onClick={() =>
                                          PaymentStatusViewHanlder(
                                            viewListDetails.lottransferpaymentranId
                                          )
                                        }
                                        className="mr-5 mt-1 float-right"
                                      >
                                        View Receipt
                                      </CButton>
                                    )}
                                  </CCol>
                                </CRow>
                              </>
                            )
                          ) : (
                            ""
                          )}
                        </CCol>
                      ) : data.isUserApproved === true &&
                        authenticated.role === "Bidder" &&
                        viewTransferDetails[viewTransferDetails.length - 1]
                          .approvedByUserId !== 0 &&
                        viewTransferDetails[viewTransferDetails.length - 1]
                          .transferFromUserId === authenticated.userId &&
                        viewPaymentDetails &&
                        viewPaymentDetails[key] &&
                        viewPaymentDetails[key]?.status === 2 ? (
                        <CCol className="mb-2" xl={2}>
                          <CButton
                            className="mt-4"
                            hidden="true"
                            onClick={() => {
                              const location = {
                                pathname: `/selectpaymentmethod/${data.lotTransferId}`,
                                state: {
                                  lotId: decrypted,
                                },
                              };

                              history.push(location);
                            }}
                            color="info"
                          >
                            Pay Transfer Fee
                          </CButton>
                        </CCol>
                      ) : data.isUserApproved === true &&
                        authenticated.role === "Bidder" &&
                        viewTransferDetails[viewTransferDetails.length - 1]
                          .approvedByUserId !== 0 &&
                        viewTransferDetails[viewTransferDetails.length - 1]
                          .transferFromUserId === authenticated.userId &&
                        viewPaymentDetails &&
                        viewPaymentDetails[key]?.filePath === null ? (
                        <CCol className="mb-2" xl={2}>
                          <CButton
                            hidden="true"
                            className="mt-4"
                            // to={`/selectpaymentmethod/${data.lotTransferId}`}
                            onClick={() => {
                              const location = {
                                pathname: `/selectpaymentmethod/${data.lotTransferId}`,
                                state: {
                                  lotId: decrypted,
                                },
                              };

                              history.push(location);
                            }}
                            color="info"
                          >
                            Pay Transfer Fee
                          </CButton>
                        </CCol>
                      ) : (
                        ""
                      )}
                    </CRow>
                  </div>
                ))}
              </>
            )}

            {viewListDetails &&
            authenticated.role === "Bidder" &&
            viewListDetails.addAmount > 0 ? (
              <>
                {EmdPaid.isEMDPaid === false ? (
                  <CRow className="pl-5 pr-5 mt-3">
                    <CCol xl={6}>
                      {viewTransferDetails.length === 0
                        ? EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                          EmdPaid.lotPaymentViewModel?.paymentNotes !== ""
                          ? EmdPaid.lotPaymentViewModel?.paymentNotes
                          : "You have to pay additional amount for security to proceed further."
                        : ""}
                      <br></br>
                      <CButton
                        hidden="true"
                        className="mt-3"
                        color="success"
                        disabled={
                          viewListDetails.isDisableUploadDocumentForBidder
                        }
                        // hidden={viewTransferDetails.length === 0 ? false : true}
                        onClick={() =>
                          PaymentHanlder(viewListDetails.addAmount)
                        }
                      >
                        Pay
                      </CButton>
                      <CButton
                        hidden="true"
                        className="ml-2 mt-3"
                        disabled={
                          viewListDetails.isDisableUploadDocumentForBidder
                        }
                        // hidden={viewTransferDetails.length === 0 ? false : true}
                        onClick={() =>
                          BGPaymentHandler(viewListDetails.lotId, "EDI")
                        }
                        color="success"
                      >
                        Bank Guarantee Payment
                      </CButton>
                    </CCol>
                  </CRow>
                ) : authenticated.role === "Bidder" &&
                  viewListDetails.status !== "Terminated" &&
                  EmdPaid.lotPaymentViewModel?.isPayNowAllow &&
                  viewTenderDetails.isAgreementLetterGenerated &&
                  viewListDetails.isAgreementAccepted === 1 ? (
                  <>{EmdPaid.isEmdPaid}</>
                ) : EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
                  !EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
                    "Challan"
                  ) &&
                  EmdPaid.lotPaymentViewModel?.tranId !== null ? (
                  <CRow className="pl-5 pr-5 mt-3">
                    <CCol xl={12} className="mt-4">
                      {/* You have to pay additional amount for security to proceed further. <br/>
                              {EmdPaid.lotPaymentViewModel?.paymentNotes} */}

                      {EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                      EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
                      viewTransferDetails.length === 0 ? (
                        <>
                          <strong>Emd Payment</strong>
                          <hr></hr>
                          {EmdPaid.lotPaymentViewModel?.paymentNotes}
                        </>
                      ) : viewTransferDetails.length === 0 ? (
                        "You have to pay additional amount for security to proceed further."
                      ) : (
                        ""
                      )}

                      <CButton
                        color="info"
                        hidden={viewTransferDetails.length === 0 ? false : true}
                        onClick={() =>
                          PaymentStatusViewHanlder(
                            EmdPaid.lotPaymentViewModel?.tranId
                          )
                        }
                        className="mr-5 mt-1 float-right"
                      >
                        View Receipt
                      </CButton>
                    </CCol>
                  </CRow>
                ) : authenticated.role === "Bidder" &&
                  EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
                  EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
                    "Challan"
                  ) &&
                  EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
                    "Awai ting"
                  ) ? (
                  <CRow className="pl-5 pr-5 mt-3">
                    <CCol xl={6} className="mt-4">
                      {/* You have to pay additional amount for security to proceed further. <br/>
                              {EmdPaid.lotPaymentViewModel?.paymentNotes} */}

                      {EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                      EmdPaid.lotPaymentViewModel?.paymentNotes !== ""
                        ? EmdPaid.lotPaymentViewModel?.paymentNotes
                        : "You have to pay additional amount for security to proceed further."}
                      <br />
                      <CButton
                        color="info"
                        onClick={() =>
                          PaymentStatusViewHanlder(
                            EmdPaid.lotPaymentViewModel?.tranId
                          )
                        }
                        className="mr-5 mt-1 float-right"
                      >
                        View Receipt
                      </CButton>
                      <CButton
                        hidden="true"
                        color="info"
                        onClick={() =>
                          CancelChallanHanlder(
                            EmdPaid.lotPaymentViewModel?.paymentId
                          )
                        }
                        className="mr-5 mt-1 float-right"
                      >
                        Cancel Challan
                      </CButton>
                    </CCol>
                  </CRow>
                ) : EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
                  EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
                    "Challan"
                  ) &&
                  !EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
                    "Awaiting"
                  ) ? (
                  <CRow className="pl-5 pr-5 mt-3">
                    <CCol xl={6} className="mt-4">
                      {/* You have to pay additional amount for security to proceed further. <br/>
                            {EmdPaid.lotPaymentViewModel?.paymentNotes} */}
                      {EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                      EmdPaid.lotPaymentViewModel?.paymentNotes !== ""
                        ? EmdPaid.lotPaymentViewModel?.paymentNotes
                        : "You have to pay additional amount for security to proceed further."}
                      <br />
                      <CButton
                        color="info"
                        onClick={() =>
                          PaymentStatusViewHanlder(
                            EmdPaid.lotPaymentViewModel?.tranId
                          )
                        }
                        className="mr-5 mt-1 float-right"
                      >
                        View Receipt
                      </CButton>
                    </CCol>
                  </CRow>
                ) : (
                  authenticated.role !== "CGMF" && (
                    <CRow className="pl-5 pr-5 mt-3">
                      <CCol xl={6} className="mt-4">
                        {/* You have to pay additional amount for security to proceed further. <br/>
                             {EmdPaid.lotPaymentViewModel?.paymentNotes} */}

                        {EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                        EmdPaid.lotPaymentViewModel?.paymentNotes !== ""
                          ? EmdPaid.lotPaymentViewModel?.paymentNotes
                          : "You have to pay additional amount for security to proceed further."}
                        {EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
                        EmdPaid.lotPaymentViewModel?.tranId !== null ? (
                          <CButton
                            color="info"
                            onClick={() =>
                              PaymentStatusViewHanlder(
                                EmdPaid.lotPaymentViewModel?.tranId
                              )
                            }
                            className="mr-5 mt-1 float-right"
                          >
                            View Receipt
                          </CButton>
                        ) : (
                          <a
                            target="_blank"
                            href={`${downloadUrl}/${EmdPaid.lotPaymentViewModel.filePath}`}
                            rel="noreferrer"
                          >
                            <CButton
                              color="info"
                              className="mr-5 mt-1 float-right"
                            >
                              View BG
                            </CButton>
                          </a>
                        )}
                      </CCol>
                    </CRow>
                  )
                )}
              </>
            ) : (
              ""
            )}

            <div className="pl-5 pr-5">
              {viewListDetails.isTransferFeePaidStatusSuccess === true ? (
                <>
                  {console.log(
                    "viewListDetails.lottransfer25emdpaymentdescription :" +
                      viewListDetails.lottransfer25emdpaymentdescription
                  )}
                  <strong>Transfer lot EMD payment</strong>
                  <hr></hr>
                  <CRow>
                    <CCol className="col-2">
                      <strong className="ml-2">
                        Amount : {viewListDetails.amount25}
                      </strong>
                      <CButton
                        className="mt-2 ml-2 mr-2"
                        color="success"
                        variant="outline"
                        hidden="true"
                        disabled={
                          viewListDetails.isTransferLotEMDPaid === true ||
                          viewListDetails.isTransferLotEMD25Paid === true ||
                          viewListDetails.isTransferLotEMD15Paid === true ||
                          viewListDetails.isTransferLotEMD10Paid === true
                            ? true
                            : false
                        }
                        onClick={() => TransferLotEMDPayment(25)}
                      >
                        Paid 25% VIA PG
                      </CButton>
                      {viewListDetails.lottransfer25emdpaymentdescription !==
                        undefined &&
                      viewListDetails.lottransfer25emdpaymentdescription !==
                        "" &&
                      viewListDetails.lottransfer25emdpaymentdescription !==
                        null ? (
                        <>
                          <br></br>
                          {viewListDetails.lottransfer25emdpaymentdescription}
                          <br></br>
                          <CButton
                            color="info"
                            onClick={() =>
                              PaymentStatusViewHanlder(
                                viewListDetails.lottransfer25emdpaymentidtranId
                              )
                            }
                            className="mr-5 mt-1 float-right"
                          >
                            View Receipt
                          </CButton>
                        </>
                      ) : (
                        ""
                      )}
                    </CCol>
                    <CCol className="col-1 mt-2 ml-2 mr-2">OR</CCol>
                    <CCol className="col-2">
                      <strong className="ml-2">
                        Amount : {viewListDetails.amount10}
                      </strong>
                      <CButton
                        className="mt-2 ml-2 mr-2"
                        color="success"
                        variant="outline"
                        hidden="true"
                        disabled={
                          viewListDetails.isTransferLotEMDPaid === true ||
                          viewListDetails.isTransferLotEMD10Paid === true
                            ? true
                            : false
                        }
                        onClick={() => TransferLotEMDPayment(10)}
                      >
                        Paid 10% VIA PG
                      </CButton>

                      {viewListDetails.lottransfer10emdpaymentdescription !==
                        undefined &&
                      viewListDetails.lottransfer10emdpaymentdescription !==
                        "" &&
                      viewListDetails.lottransfer10emdpaymentdescription !==
                        null ? (
                        <>
                          <br></br>
                          {viewListDetails.lottransfer10emdpaymentdescription}
                          <br></br>
                          <CButton
                            hidden="true"
                            color="info"
                            onClick={() =>
                              PaymentStatusViewHanlder(
                                viewListDetails.lottransfer10emdpaymentidtranId
                              )
                            }
                            className="mr-5 mt-1 float-right"
                          >
                            View Receipt
                          </CButton>
                        </>
                      ) : (
                        ""
                      )}
                    </CCol>
                    <CCol className="col-2">
                      <strong className="ml-2">
                        Amount : {viewListDetails.amount15}
                      </strong>
                      <CButton
                        hidden="true"
                        className="mt-2 ml-2 mr-2"
                        color="success"
                        variant="outline"
                        disabled={
                          viewListDetails.isTransferLotEMDPaid === true ||
                          viewListDetails.isTransferLotEMD15Paid === true
                            ? true
                            : false
                        }
                        onClick={() => TransferLotEMDPayment(15)}
                      >
                        Paid 15% VIA PG/BG/FDR
                      </CButton>

                      {viewListDetails.lottransfer15emdpaymentdescription !==
                        undefined &&
                      viewListDetails.lottransfer15emdpaymentdescription !==
                        "" &&
                      viewListDetails.lottransfer15emdpaymentdescription !==
                        null ? (
                        <>
                          <br></br>
                          {viewListDetails.lottransfer15emdpaymentdescription}
                          <br></br>
                          {viewListDetails.is15EmdTransferBG === true ? (
                            <a
                              target="_blank"
                              href={`${downloadUrl}/Documents/BG/${viewListDetails.bgPath15EmdTransferlotfilepath}`}
                              rel="noreferrer"
                            >
                              <CButton
                                color="info"
                                className="mr-5 mt-1 float-right"
                              >
                                View BG
                              </CButton>
                            </a>
                          ) : (
                            <CButton
                              color="info"
                              onClick={() =>
                                PaymentStatusViewHanlder(
                                  viewListDetails.lottransfer15emdpaymentidtranId
                                )
                              }
                              className="mr-5 mt-1 float-right"
                            >
                              View Receipt
                            </CButton>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </CCol>
                  </CRow>
                </>
              ) : (
                ""
              )}

              {/* {authenticated.role === "Bidder" && (
                  <CButton className="mt-5" color="success">
                    Accept
                  </CButton>
                )} */}

              {viewListDetails
                ? authenticated.role === "Bidder" &&
                  viewTransferDetails.length === 0
                  ? viewListDetails.status !== "Terminated" &&
                    viewTenderDetails?.isSanctionLetterGenerated &&
                    viewListDetails.isSanctionAccepted === 1 &&
                    viewTenderDetails?.isAgreementLetterGenerated &&
                    viewListDetails.isAgreementAccepted === 1 &&
                    viewListDetails.isCCFSignedAgreement === true &&
                    viewListDetails.isBidderAllowToTransferLot === true && (
                      <>
                        <CButton
                          hidden="true"
                          className="mt-5  mr-2"
                          color="info"
                          onClick={() => history.push(`/transferlot/${lotId}`)}
                        >
                          Transfer
                        </CButton>
                      </>
                    )
                  : authenticated.role === "Bidder" &&
                    viewTransferDetails &&
                    viewTransferDetails[viewTransferDetails.length - 1]
                      .status === 2
                  ? viewListDetails.status !== "Terminated" &&
                    viewTenderDetails?.isSanctionLetterGenerated &&
                    viewListDetails.isSanctionAccepted === 1 &&
                    viewTenderDetails?.isAgreementLetterGenerated &&
                    viewListDetails.isAgreementAccepted === 1 &&
                    viewListDetails.isCCFSignedAgreement === true &&
                    viewListDetails.isBidderAllowToTransferLot === true && (
                      <CButton
                        hidden="true"
                        className="mt-5  mr-2"
                        color="info"
                        onClick={() => history.push(`/transferlot/${lotId}`)}
                      >
                        Transfer
                      </CButton>
                    )
                  : ""
                : ""}
              {/* {authenticated.role === "CGMF" &&
                  viewListDetails.status !== "Terminated" && (
                    <CButton
                      onClick={handleOpen}
                      className="mt-5 mr-2"
                      color="danger"
                    >
                      Terminate Lot
                    </CButton>
                  )} */}
              {viewListDetails &&
              viewTenderDetails &&
              authenticated.role === "Bidder" &&
              viewTenderDetails?.isSanctionLetterGenerated &&
              viewListDetails.isSanctionAccepted === 0 &&
              viewTransferDetails.length === 0 ? (
                <>
                  <a
                    href={`${apiCall.downloadUrl}/${viewListDetails?.sanctionLetterPath}`}
                    target="_blank"
                    className=""
                    rel="noreferrer"
                  >
                    <CButton className="mt-5 mr-2" color="success">
                      View Sanction Letter
                    </CButton>
                  </a>
                  <CButton
                    hidden="true"
                    className="mt-5"
                    color="success"
                    variant="outline"
                    onClick={() => updateSanction(1)}
                  >
                    Accept Sanction
                  </CButton>
                  <CButton
                    hidden="true"
                    className="mt-5 ml-2 mr-2"
                    color="danger"
                    variant="outline"
                    onClick={() => updateSanction(2)}
                  >
                    Reject Sanction
                  </CButton>
                </>
              ) : viewListDetails &&
                viewTenderDetails &&
                authenticated.role === "Bidder" &&
                viewTenderDetails?.isSanctionLetterGenerated &&
                viewPaymentDetails.length > 0 &&
                viewTransferDetails[viewTransferDetails.length - 1]?.status !==
                  0 &&
                viewPaymentDetails[viewPaymentDetails.length - 1]?.status ===
                  1 &&
                viewListDetails.isSanctionAccepted === 0 &&
                viewTransferDetails.length > 0 &&
                viewPaymentDetails[viewPaymentDetails.length - 1]
                  ?.paidByUser !== null ? (
                <>
                  <a
                    href={`${apiCall.downloadUrl}/${viewListDetails?.sanctionLetterPath}`}
                    target="_blank"
                    className=""
                    rel="noreferrer"
                  >
                    <CButton className="mt-5 mr-2" color="success">
                      View Sanction Letter
                    </CButton>
                  </a>
                  <CButton
                    hidden="true"
                    className="mt-5"
                    color="success"
                    variant="outline"
                    onClick={() => updateSanction(1)}
                  >
                    Accept Sanction
                  </CButton>
                  <CButton
                    hidden="true"
                    className="mt-5 ml-2 mr-2"
                    color="danger"
                    variant="outline"
                    onClick={() => updateSanction(2)}
                  >
                    Reject Sanction
                  </CButton>
                </>
              ) : (
                ""
              )}

              {authenticated.role === "Bidder" ? (
                <>
                  <CButton
                    className="mt-5 ml-2 mr-2"
                    color="success"
                    variant="outline"
                    hidden="true"
                    disabled={viewListDetails.isDisableUploadDocumentForBidder}
                    onClick={() =>
                      handleOpenagreementextend7day(
                        viewListDetails.lotId,
                        viewListDetails.lotNo,
                        viewListDetails.bidderExtention7DayDate,
                        viewListDetails.day7Amount,
                        viewListDetails.day7AmountDescription
                      )
                    }
                  >
                    Agrement Extend - 7Day
                  </CButton>

                  <CButton
                    className="mt-5 ml-2 mr-2"
                    color="success"
                    variant="outline"
                    hidden="true"
                    disabled={viewListDetails.isDisableUploadDocumentForBidder}
                    onClick={() =>
                      handleOpenagreementextend15March(
                        viewListDetails.lotId,
                        viewListDetails.lotNo,
                        viewListDetails.bidderExtention15MarchDate,
                        viewListDetails.march15Amount,
                        viewListDetails.march15Description
                      )
                    }
                  >
                    Agrement Extend Upto 15March
                  </CButton>
                </>
              ) : (
                ""
              )}

              {console.log("authenticated.role : " + authenticated.role)}
              {console.log(
                "viewTenderDetails?.isSanctionLetterGenerated : " +
                  viewTenderDetails?.isSanctionLetterGenerated
              )}
              {console.log(
                "viewListDetails.isSanctionAccepted : " +
                  viewListDetails.isSanctionAccepted
              )}
              {console.log(
                "viewTenderDetails?.isAgreementLetterGenerated : " +
                  viewTenderDetails?.isAgreementLetterGenerated
              )}
              {console.log(
                "viewListDetails.isAgreementAccepted : " +
                  viewListDetails.isAgreementAccepted
              )}
              {console.log(
                "viewListDetails.isTransferLotEMDPaid : " +
                  viewListDetails.isTransferLotEMDPaid
              )}
              {console.log(
                "viewTransferDetails.length : " + viewTransferDetails.length
              )}

              {viewListDetails &&
              EmdPaid.isEMDPaid === true &&
              viewTenderDetails &&
              authenticated.role === "Bidder" &&
              viewTenderDetails?.isSanctionLetterGenerated &&
              viewListDetails.isSanctionAccepted === 1 &&
              viewTenderDetails?.isAgreementLetterGenerated &&
              viewListDetails.isAgreementAccepted === 1 &&
              viewTransferDetails.length === 0 ? (
                <>
                  <a
                    href={`${downloadUrl}/${viewListDetails?.agreementLetterPath}`}
                    target="_blank"
                    className=""
                    rel="noreferrer"
                  >
                    <CButton
                      className="mt-5 mr-2"
                      color="success"
                      hidden="true"
                    >
                      View Agreement Letter
                    </CButton>
                  </a>
                  <CButton
                    className="mt-5 ml-2 mr-2"
                    color="success"
                    variant="outline"
                    onClick={() =>
                      handleDownloadAgreementLetter(
                        viewListDetails.tenderId,
                        viewListDetails.lotId,
                        viewListDetails.userId
                      )
                    }
                  >
                    Download Agreement Letter
                  </CButton>

                  <CButton
                    className="mt-5"
                    color="success"
                    variant="outline"
                    hidden="true"
                    onClick={() => updateAgreement(1)}
                  >
                    Accept Agreement
                  </CButton>
                  <CButton
                    className="mt-5 ml-2 mr-2"
                    color="danger"
                    variant="outline"
                    hidden="true"
                    onClick={() => updateAgreement(2)}
                  >
                    Reject Agreement
                  </CButton>
                </>
              ) : viewListDetails &&
                viewTenderDetails &&
                authenticated.role === "Bidder" &&
                viewTenderDetails?.isSanctionLetterGenerated &&
                viewListDetails.isSanctionAccepted === 1 &&
                viewTenderDetails?.isAgreementLetterGenerated &&
                // viewPaymentDetails.length > 0 &&
                // viewTransferDetails[viewTransferDetails.length - 1]?.status !== 0 &&
                // viewPaymentDetails[viewPaymentDetails.length - 1]?.status === 1 &&
                (viewListDetails.isAgreementAccepted === 1 ||
                  viewListDetails.isTransferLotEMDPaid === true) &&
                viewListDetails.isTransferLotEMDPaid === true &&
                viewTransferDetails.length > 0 ? (
                // viewPaymentDetails[viewPaymentDetails.length - 1]?.paidByUser !== null
                <>
                  <a
                    href={`${apiCall.downloadUrl}/${viewListDetails?.agreementLetterPath}`}
                    target="_blank"
                    className=""
                    rel="noreferrer"
                  >
                    <CButton
                      className="mt-5 mr-2"
                      color="success"
                      hidden="true"
                    >
                      View Agreement Letter
                    </CButton>
                  </a>
                  <CButton
                    className="mt-5 ml-2 mr-2"
                    color="success"
                    variant="outline"
                    onClick={() =>
                      handleDownloadAgreementLetter(
                        viewListDetails.tenderId,
                        viewListDetails.lotId,
                        viewListDetails.userId
                      )
                    }
                  >
                    Download Agreement Letter
                  </CButton>

                  <CButton
                    className="mt-5"
                    color="success"
                    variant="outline"
                    hidden="true"
                    onClick={() => updateAgreement(1)}
                  >
                    Accept Agreement
                  </CButton>
                  <CButton
                    className="mt-5 ml-2 mr-2"
                    color="danger"
                    variant="outline"
                    hidden="true"
                    onClick={() => updateAgreement(2)}
                  >
                    Reject Agreement
                  </CButton>
                </>
              ) : (
                ""
              )}

              {viewListDetails.isTransferLatterGenerated ? (
                <CButton
                  className="mt-5 ml-2 mr-2"
                  color="success"
                  variant="outline"
                  onClick={() => DownloadTransferLetter(viewListDetails.lotId)}
                >
                  Download Transfer Latter
                </CButton>
              ) : (
                ""
              )}

              <CButton
                className="mt-5"
                color="dark"
                onClick={() => history.goBack()}
              >
                Go Back
              </CButton>
              <br></br>
              {viewListDetails?.day7ExtentionNotes ? (
                <>
                  <strong>7 Day Extention: </strong>
                  {viewListDetails?.day7ExtentionNotes}
                  <CButton
                    color="info"
                    onClick={() =>
                      PaymentStatusViewHanlder(
                        viewListDetails?.day7paymenttranId
                      )
                    }
                    className="mr-5 mt-1 ml-2"
                  >
                    View Receipt
                  </CButton>
                  <strong>CCF status: </strong> : {viewListDetails?.day7Status}
                </>
              ) : (
                ""
              )}
              <br></br>
              {viewListDetails?.march15ExtentionNotes ? (
                <>
                  <strong>15 March Extention: </strong>
                  {viewListDetails?.march15ExtentionNotes}
                  <CButton
                    color="info"
                    onClick={() =>
                      PaymentStatusViewHanlder(
                        viewListDetails?.march15paymenttranId
                      )
                    }
                    className="mr-5 mt-1 ml-2"
                  >
                    View Receipt
                  </CButton>
                  <strong>HO status: </strong> :{" "}
                  {viewListDetails?.march15Status}
                </>
              ) : (
                ""
              )}

              {isAnyPaidSlots > 0 &&
              (authenticated.role === "CFO" || authenticated.role === "DFO") ? (
                <>
                  <CButton
                    hidden="true"
                    className="mt-5 ml-3"
                    color="success"
                    variant="outline"
                    onClick={() => generateAadeshLetter()}
                  >
                    Generate Paridhan Aadesh
                  </CButton>
                </>
              ) : (
                ""
              )}
            </div>

            {/* 
              //&&
                // EmdPaid.isEMDPaid == true &&
                // viewTenderDetails &&
                // authenticated.role === "Bidder" &&
                // viewTenderDetails?.isSanctionLetterGenerated &&
                // viewListDetails.isSanctionAccepted === 1 &&
                // viewTenderDetails?.isAgreementLetterGenerated &&
                // viewListDetails.isAgreementAccepted === 1 &&
                // viewTransferDetails.length === 0  */}

            <div className="pl-5 pr-5 mt-3">
              {viewListDetails
                ? authenticated.role === "Bidder" &&
                  viewTransferDetails.length === 0
                  ? viewListDetails.status !== "Terminated" &&
                    viewTenderDetails?.isSanctionLetterGenerated &&
                    viewListDetails.isSanctionAccepted === 1 &&
                    viewTenderDetails?.isAgreementLetterGenerated &&
                    viewListDetails.isAgreementAccepted === 1 &&
                    viewListDetails.isCCFSignedAgreement === true &&
                    viewListDetails.isBidderAllowToTransferLot === true && (
                      <>
                        <CLabel>
                          <strong>Note: </strong>
                        </CLabel>
                        <CLabel
                          style={{
                            fontStyle: "italic",
                          }}
                        >
                          {viewListDetails.bidderAllowToTransferLotLastDate}
                        </CLabel>
                        <br></br>
                      </>
                    )
                  : authenticated.role === "Bidder" &&
                    viewTransferDetails &&
                    viewTransferDetails[viewTransferDetails.length - 1]
                      .status === 2
                  ? viewListDetails.status !== "Terminated" &&
                    viewTenderDetails?.isSanctionLetterGenerated &&
                    viewListDetails.isSanctionAccepted === 1 &&
                    viewTenderDetails?.isAgreementLetterGenerated &&
                    viewListDetails.isAgreementAccepted === 1 &&
                    viewListDetails.isCCFSignedAgreement === true &&
                    viewListDetails.isBidderAllowToTransferLot === true && (
                      <>
                        <CLabel>
                          <strong>Note: </strong>
                        </CLabel>
                        <CLabel
                          style={{
                            fontStyle: "italic",
                          }}
                        >
                          {viewListDetails.bidderAllowToTransferLotLastDate}
                        </CLabel>
                        <br></br>
                      </>
                    )
                  : ""
                : ""}

              {viewListDetails ? (
                viewListDetails?.bidderLastDateOfAgreement !== null &&
                viewListDetails?.bidderLastDateOfAgreement !== "" ? (
                  <>
                    <CLabel>
                      <strong>Note: </strong>
                    </CLabel>
                    <CLabel
                      style={{
                        fontStyle: "italic",
                      }}
                    >
                      {viewListDetails.bidderLastDateOfAgreement}
                    </CLabel>
                  </>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              <br></br>
              <CLabel
                style={{
                  fontStyle: "italic",
                  color: "red",
                }}
              >
                <strong>Note: </strong> If you have completed payment
                transaction via Payment Gateway and it is not showing
                (success/failure) then please wait for 15 minutes to retry the
                payment transaction.
              </CLabel>
              {viewListDetails &&
              EmdPaid.isEMDPaid === true &&
              viewTenderDetails &&
              authenticated.role === "CFO" &&
              viewTenderDetails?.isSanctionLetterGenerated &&
              viewListDetails.isSanctionAccepted === 1 &&
              viewTenderDetails?.isAgreementLetterGenerated &&
              viewListDetails.isAgreementAccepted === 1 &&
              viewTransferDetails.length === 0 ? (
                viewListDetails?.cfoLastDateOfAgreement !== null &&
                viewListDetails?.cfoLastDateOfAgreement !== "" ? (
                  <>
                    <CLabel>
                      <strong>Note: </strong>
                    </CLabel>
                    <CLabel
                      style={{
                        fontStyle: "italic",
                      }}
                    >
                      {viewListDetails?.cfoLastDateOfAgreement}
                    </CLabel>
                  </>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </div>
            <div>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropComponent={Backdrop}
              >
                <Paper style={style} elevation={3}>
                  <CForm className="needs-validation" onSubmit={terminateLot}>
                    <CRow>
                      <CCol>
                        <CLabel>Reason for termination:</CLabel>
                        <CTextarea
                          onChange={(e) => setterminationMsg(e.target.value)}
                          required
                        />
                      </CCol>
                    </CRow>
                    <CRow
                      style={{
                        marginLeft: "7rem",
                      }}
                    >
                      <CCol>
                        <CButton
                          className="mt-3"
                          color="success"
                          type="submit"
                          hidden="true"
                        >
                          Terminate
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </Paper>
              </Modal>
            </div>
            <div>
              <Modal
                open={openRevoke}
                onClose={handleCloseRevoke}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropComponent={Backdrop}
              >
                <Paper style={style} elevation={3}>
                  <CForm className="needs-validation" onSubmit={revokeLot}>
                    <CRow>
                      <CCol>
                        <CLabel>Reason to revoke:</CLabel>
                        <CTextarea
                          onChange={(e) => setrevokeMsg(e.target.value)}
                          required
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CLabel>Date:</CLabel>
                        <CInput
                          type="date"
                          onChange={(e) => setrevokeDate(e.target.value)}
                          required
                        />
                      </CCol>
                    </CRow>
                    <CRow
                      style={{
                        marginLeft: "7rem",
                      }}
                    >
                      <CCol>
                        <CButton className="mt-3" color="success" type="submit">
                          Revoke
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </Paper>
              </Modal>
            </div>
            <div>
              <Modal
                open={agreementextendopen}
                onClose={handleagreementextendclose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropComponent={Backdrop}
              >
                <Paper style={style} elevation={3}>
                  <CForm
                    className="needs-validation"
                    onSubmit={submitAgreementExtend7Day}
                  >
                    <CRow>
                      <CCol>
                        <CLabel>LotNo: {agreementextendLotNo}</CLabel>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CLabel>Extention Date:</CLabel>
                        <CLabel>{agreementextendLastDate}</CLabel>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CLabel>
                          Amount: {agreementextendamount}{" "}
                          {agreementextendamountdescription}
                        </CLabel>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <CLabel>Extention Comment:</CLabel>
                        <CTextarea
                          rows="5"
                          onChange={(e) =>
                            setagreementextendComments(e.target.value)
                          }
                          required
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol style={{ textAlign: "right" }}>
                        <CButton
                          className="mt-3"
                          color="success"
                          onClick={() => HandlerAgreementPay()}
                        >
                          Pay
                        </CButton>
                        <CButton
                          className="mt-3 ml-2 mr-2 btn-dark"
                          onClick={(e) => {
                            alert(e.target.value);
                          }}
                        >
                          Cancel
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </Paper>
              </Modal>
            </div>
          </CCardHeader>
        )
      )}
    </>
  );
};
export default TransferLotDetails;
